export function delphiTColorToCss(value: number): string | null {
  if (!Number.isFinite(value)) return null;
  const v = Math.trunc(value);
  if (v < 0) {
    return null;
  }
  const x = v & 0xffffff;
  const r = x & 0xff;
  const g = (x >> 8) & 0xff;
  const b = (x >> 16) & 0xff;
  return `rgb(${r}, ${g}, ${b})`;
}

const DELPHI_NAMED_COLORS: Record<string, string> = {
  clblack: "#000000",
  clmaroon: "#800000",
  clgreen: "#008000",
  clolive: "#808000",
  clnavy: "#000080",
  clpurple: "#800080",
  clteal: "#008080",
  clgray: "#808080",
  clsilver: "#c0c0c0",
  clred: "#ff0000",
  cllime: "#00ff00",
  clyellow: "#ffff00",
  clblue: "#0000ff",
  clfuchsia: "#ff00ff",
  claqua: "#00ffff",
  clwhite: "#ffffff",
  clwindow: "#ffffff",
  clwindowtext: "#101010",
  clbtnface: "#f0f0f0",
  clbtntext: "#101010",
  clcaptiontext: "#ffffff",
  clinactivecaption: "#a0a0a0",
  clmenu: "#f0f0f0",
  clmenutext: "#101010",
  clinfobk: "#ffffe1",
  clinfotext: "#101010",
};

export function resolveDelphiColor(raw: unknown): string | null {
  if (raw == null) return null;
  if (typeof raw === "number" && Number.isFinite(raw)) {
    return delphiTColorToCss(raw);
  }
  if (typeof raw === "string") {
    const t = raw.trim();
    if (!t) return null;
    if (/^cl/i.test(t)) {
      const key = t.toLowerCase();
      if (DELPHI_NAMED_COLORS[key]) return DELPHI_NAMED_COLORS[key];
    }
    if (t.startsWith("#")) return t;
    if (/^[0-9a-fA-F]{6}$/.test(t) || /^[0-9a-fA-F]{3}$/.test(t)) return `#${t}`;
  }
  return null;
}
